
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elallas",
      function () {
        return require("private-next-pages/elallas.tsx");
      }
    ]);
  